// extracted by mini-css-extract-plugin
module.exports = {"main":"_3KUfUkprbRjLvII4I7QTr0","content":"_3D7ZVCVGG8eHtyaCZzHKNK","voltar":"_1ywvrxh0nUeywd3KXhDH9o","gridWrapper":"_35dTd3-w3ecvQuu-XNs8R7"};